import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { queryOptions } from '@tanstack/react-query';

import { msalScopes } from '~config';
import { fetchUserProfile } from './msGraphService';

export const userProfileKeys = {
  all: ['msGraph', 'userProfile'] as const,
  byAccount: (accountId: string | undefined) => ['msGraph', 'userProfile', accountId] as const,
};

export function userProfileQueryOptions(instance: IPublicClientApplication, account: AccountInfo | null) {
  return queryOptions({
    queryKey: userProfileKeys.byAccount(account?.homeAccountId),
    queryFn: async () => {
      if (!account) return null;
      return fetchUserProfile(instance, account, [...msalScopes.graph]);
    },
    enabled: !!account,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
    retry: 1,
  });
}
